var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    className: "text-foreground-inverse w-6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.582 7.2a2.51 2.51 0 0 0-1.768-1.78C18.25 5 12 5 12 5s-6.25 0-7.814.42A2.51 2.51 0 0 0 2.418 7.2C2 8.77 2 12.046 2 12.046s0 3.274.418 4.845a2.51 2.51 0 0 0 1.768 1.78c1.564.42 7.814.42 7.814.42s6.25 0 7.814-.42a2.51 2.51 0 0 0 1.768-1.78C22 15.32 22 12.046 22 12.046s0-3.276-.418-4.846m-6.4 4.846-5.227 2.973V9.072z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.2656eb1bda3b3f49fa80239b8d1fa16d.svg";
export { ForwardRef as ReactComponent };